import React from 'react';
import { FileText, ExternalLink, Download } from 'lucide-react';
import { InvoiceFile } from '../types/invoices';
import { formatBytes, formatDateFR } from '../utils/invoices';


interface Props {
  files: InvoiceFile[];
}

const FileTable: React.FC<Props> = ({ files }) => {
  if (files.length === 0)
    return <div className="p-6 text-neutral-600">Aucun fichier.</div>;

  return (
    <ul className="divide-y">
      {files.map((f) => {
        const bestDate = f.dateFromName ?? f.updated ?? null;
        return (
          <li
            key={f.fullPath}
            className="grid grid-cols-12 items-center px-4 py-3 hover:bg-neutral-50"
          >
            <div className="col-span-6 sm:col-span-7 flex items-center gap-3 min-w-0">
              <div className="rounded-lg border border-neutral-200 p-2 shrink-0">
                <FileText className="w-5 h-5" />
              </div>
              <div className="truncate">
                <div className="truncate font-medium">{f.name}</div>
                <div className="text-xs text-neutral-500 font-mono truncate">
                  /{f.fullPath}
                </div>
              </div>
            </div>
            <div className="hidden sm:block sm:col-span-3">
              {formatDateFR(bestDate)}
            </div>
            <div className="hidden sm:block sm:col-span-1">
              {formatBytes(f.size)}
            </div>
            <div className="col-span-6 sm:col-span-1">
              <div className="flex justify-end gap-2">
                <a
                  href={f.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 rounded-lg border border-neutral-200 px-2 py-1 text-sm hover:bg-neutral-100"
                  title="Ouvrir"
                >
                  <ExternalLink className="w-4 h-4" /> Ouvrir
                </a>
                <a
                  href={f.url}
                  download={f.name}
                  className="inline-flex items-center gap-1 rounded-lg border border-neutral-200 px-2 py-1 text-sm hover:bg-neutral-100"
                  title="Télécharger"
                >
                  <Download className="w-4 h-4" /> Télécharger
                </a>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default FileTable;
